import { TwoWayAuthProvider } from "@context/TwoWayAuthContext";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import * as ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { muiTheme } from "./stylesheets/themeConfiguration";
import { i18n } from "./translations/i18n";

ReactDOM.render(
    <BrowserRouter>
        <MuiThemeProvider theme={muiTheme}>
            <I18nextProvider i18n={i18n}>
                <TwoWayAuthProvider>
                    <div style={{ display: "flex" }}>
                        <App />
                    </div>
                </TwoWayAuthProvider>
            </I18nextProvider>
        </MuiThemeProvider>
    </BrowserRouter>,
    document.getElementById("app")
);
